export enum RequestStatusGroup {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Registered = 'Registered',
  PendingRegistration = 'PendingRegistration',
  NotRegistered = 'NotRegistered',
}

export type RequestStatuses = {
  [key in LoanRequestStatus]: {
    Code: number;
    Name: string;
    Description: string;
    Groups: (keyof typeof RequestStatusGroup)[];
  };
};

export enum LoanRequestStatus {
  LoanRequestStatusApplicationCompletedPendingRegistration = '211 Pending Registration',
  LoanRequestStatusApplicationCompletedDownsellAdjustment = '212 Pending Registration - Downsell Adjustment complete',
  LoanRequestStatusApplicationCompletedUpsellAdjustment = '213 Pending Registration - Upsell Adjustment Complete',
  LoanRequestStatusApplicationCompletedPendingRegistrationOther = '249 Pending Registration - Other',
  LoanRequestStatusApplicationCompletedRegistered = '251 Registered',
  LoanRequestStatusApplicationCompletedNotRegistered = '261 Not Registered',
  LoanRequestStatusApplicationCompletedNotRegisteredPIDError = '262 Not Registered - PID Error',
  LoanRequestStatusApplicationCompletedNotRegisteredAddressError = '263 Not Registered - Address Error',
  LoanRequestStatusApplicationCompletedNotRegisteredBankError = '264 Not Registered - Bank Error',
  LoanRequestStatusApplicationCompletedNotRegisteredCreditScore = '265 Not Registered - Credit Score',
  LoanRequestStatusApplicationCompletedNotRegisteredBankDisabled = '266 Not Registered - Bank Disabled',
  LoanRequestStatusApplicationCompletedNotRegisteredBankFilter = '267 Not Registered - Bank Filter',
  LoanRequestStatusApplicationCompletedNotRegisteredBankFilterCoApplicant = '268 Not Registered - Bank Filter Co Applicant',
  LoanRequestStatusApplicationCompletedNotRegisteredOther = '269 Not Registered - Other',
  LoanRequestStatusApplicationCompletedCancelledByAxo = '281 Cancelled By Axo',
  LoanRequestStatusApplicationCompletedWithdrawnByAxo = '291 Withdrawn By Axo',
}
